import React from 'react';
import "../../../helper/slickCarouselStyles";
import _ep_CAROUSEL_SIMPLE_LIST from "../components/_ep_CAROUSEL_SIMPLE_LIST";
import _ep_CAROUSEL_INCREDIBLE_LIST from "../components/_ep_CAROUSEL_INCREDIBLE_LIST";
import _ep_CAROUSEL_BUTTON_LIST from "../components/_ep_CAROUSEL_BUTTON_LIST";

const _epCarousel = (props) => {
    const carousel = props?.carousel !== undefined ? props.carousel : props;

    switch (carousel?.ViewType) {
        case "BUTTON_LIST":
            return <_ep_CAROUSEL_BUTTON_LIST carousel={carousel} />;
        case "SIMPLE_LIST":
            return <_ep_CAROUSEL_SIMPLE_LIST carousel={carousel} />;
        case "INCREDIBLE_LIST":
            return <_ep_CAROUSEL_INCREDIBLE_LIST carousel={carousel} />;
        default:
            return null;
    }
};

export default React.memo(_epCarousel);
